import "./index.scss";
import "../../locales/i18n";

import { useMutation } from "@apollo/client";
import cx from "classnames";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { TStore } from "src/types/store.types";
import { detectMobile } from "src/utils/deviceType";

import Button from "@/components/components/Button";
import { ButtonColor } from "@/components/components/Button/button.enum";
import { MessageType } from "@/components/enums";
import icons from "@/components/icons";
import RepDropdown from "@/messenger/components/RepDropdown";
import { CHAT } from "@/messenger/constants/routing";
import { representativesSelectors } from "@/messenger/ducks/entities/representatives";
import { addNotification, removeNotification } from "@/messenger/ducks/general/notifications.duck";
import { assignRepresentativeToContact } from "@/messenger/graphql/mutations";
import { TRepresentative } from "@/messenger/types/entities/representative";
import Scrollbars from "react-custom-scrollbars";
import { removeConversationAC } from "@/messenger/ducks/entities/conversations";

function Error404Convo() {

    const baseClassName = "c-error-404-convo";

    const { id } = useParams<any>();
    const { t } = useTranslation();
    const history = useHistory();

    const dispatch = useDispatch();
    const [saved, setSaved] = useState<any>(false);

    const deviceType = useSelector((state: TStore) => state.general.deviceType);
    const isMobile = detectMobile(deviceType);

    const representatives = useSelector(representativesSelectors.selectAll);

    const [assignRepresentativeToContactMutation] = useMutation(assignRepresentativeToContact, {
        onCompleted: () => {
            const notification = {
                id: `${id}_reassigned`,
                type: MessageType.NEUTRAL,
                message: t("Contact Reassigned"),
            };

            dispatch(addNotification(notification));
            setTimeout(() => dispatch(removeNotification(`${id}_reassigned`)), 3000);
            setSaved(id);
        },
    });

    const removeConversationCallback = () => {
        history.push(`/${CHAT}`);
    };

    const onSelectRepresentative = (representativeId: string) => {
        dispatch(removeConversationAC({ conversationId: id }, removeConversationCallback))
        assignRepresentativeToContactMutation({
            variables: {
                conversationId: id,
                participantId: representativeId
            },
        });

    };

    const getAssignOptionsList = (reps: TRepresentative[]) => {
        const repList = reps;
        if (reps.length > 0) {
            return repList.map(rep => ({
                label: rep.participantId,
                heading: rep.identifier.split("@")[0],
            })).sort((a, b) => a.heading.toLowerCase().localeCompare(b.heading.toLowerCase()));
        } 
        return [];
        
    };

    const handleClickBackToAllButton = () => {
        history.push(`/${CHAT}/`);
    };


    return <>
        <div className={baseClassName}>
            <Scrollbars>
                <div className={`${baseClassName}__wrapper`}>
                    {isMobile && <div className={`${baseClassName}__back_button`}>
                        <Button
                            id={"TOP_BAR_BACK_BUTTON"}
                            icon={icons.ANGLE_LEFT}
                            color={ButtonColor.SECONDARY}
                            className={cx(`${baseClassName}__back-button`, {
                                [`${baseClassName}__back-button--only-icon`]: false,
                            })}
                            onClick={handleClickBackToAllButton}
                            ariaLabel={t("Top Bar Back Button")}
                        >
                            <div className={`${baseClassName}__back-button-text`}>
                                {t("Chats")}
                            </div>
                        </Button>
                    </div>}
                    <div className={`${baseClassName}__header`}>
                        This conversation isn't available to you yet.
                    </div>
                    <div className={`${baseClassName}__subheader`}>
                        It is assigned to someone else or may be expired.<br />
                    </div>
                    {saved === id ?
                        (<div className={`${baseClassName}__subheader`}>
                            <br /><strong>✔️ Assignment saved!</strong><br />
                        </div>) :
                        (<div className={`${baseClassName}__subheader`}>
                            <br />
                            Try assigning it to yourself or someone new:
                            <br /><br />
                            <RepDropdown options={getAssignOptionsList(representatives)} currentUser={"Select user"} onSelectRepresentative={onSelectRepresentative} />
                        </div>)
                    }
                </div>
            </Scrollbars>
        </div>
    </>;
}

export default Error404Convo;